import { Outlet } from "react-router-dom";
import { useCurrentUser } from "../lib/useCurrentUser";
import type { Role } from "../lib/types";

export default function RoleGuard({ allow }: { allow: Role[] }) {
  const { user, loading, error } = useCurrentUser();

  if (loading) {
    return (
      <div className="container-page py-20">
        <div className="surface mx-auto max-w-md p-6 text-center text-sm text-slate-300">
          <div className="mx-auto h-2 w-2 animate-pulse rounded-full bg-accent" />
          <p className="mt-3">Verifying access…</p>
        </div>
      </div>
    );
  }
  if (error || !user) {
    return (
      <div className="container-page py-20">
        <div className="surface mx-auto max-w-xl p-8">
          <h2 className="text-xl font-semibold text-white">
            Couldn't verify your account
          </h2>
          <p className="mt-2 text-sm text-slate-300">
            {error ??
              "We don't have a profile for your account yet. Sign out and back in, or contact a platform admin."}
          </p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="mt-4 rounded-md border border-white/10 px-3 py-1.5 text-xs text-slate-200 hover:bg-white/5"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
  if (!allow.includes(user.role)) {
    return (
      <div className="container-page py-20">
        <div className="surface mx-auto max-w-xl p-8 text-center">
          <h2 className="text-xl font-semibold text-white">
            Access restricted
          </h2>
          <p className="mt-2 text-sm text-slate-400">
            This area is limited to specific community roles. If you think you
            should have access, contact your platform admin.
          </p>
        </div>
      </div>
    );
  }
  return <Outlet />;
}
